'use client';

import SearchInput from '@/components/common/layout/secondary-app-bar/search-input/search-input';
import useHeaderContent from '@/hooks/use-header-content';
import { useResolveThemeColor } from '@/hooks/use-resolve-theme-color';

type Props = {
  /** Mirrors which header wraps this strip so the colour matches that header's main row. */
  variant?: 'default' | 'secondary';
};

const MobileSearch = ({ variant = 'default' }: Props) => {
  const resolveThemeColor = useResolveThemeColor();
  const headerContent = useHeaderContent();

  const mainRowBackground =
    variant === 'secondary'
      ? resolveThemeColor(headerContent.background ?? 'foreground')
      : resolveThemeColor(headerContent.mainBackground ?? headerContent.background ?? 'content1');

  return (
    // `pb-2` (not `mb-2`) keeps the bottom spacing INSIDE the painted area so
    // the page content scrolling underneath the sticky header doesn't bleed
    // through a transparent margin strip.
    <div
      className="mx-auto block w-full px-8 pb-2 @lg:hidden"
      style={{ background: mainRowBackground }}
    >
      <SearchInput />
    </div>
  );
};

export default MobileSearch;
